export enum UserRoles {
  None = 0,
  Admin = 1,
  Manager = 2,
  Advocate = 3,
  GTFS = 4,
  WWCD = 5,
  CENOPS = 6
}
